import React from 'react';

import Link from '@zego/components/Link';

import withPromotionsLayout from '../withPromotionsLayout';
import {
  Content,
  IrelandTaxiBaseLandingPage,
  ProductLogo,
} from './IrelandTaxiBaseLandingPage';

import FreeNowSocial from '@zego/static/images/social/social-freenow.jpg';
import FreeNowLogo from '@zego/static/svgs/FreeNowLogo.svg';

const IrelandTaxiFreeNowLandingPage = () => (
  <IrelandTaxiBaseLandingPage
    name="Free Now Landing Page IE"
    logo={<ProductLogo src={FreeNowLogo} top={-8} />}
    title="Get on the road with FREE NOW!"
    dotInfo={
      <>
        <strong>Prices from</strong>
        €150/mth* €1,460/yr*
      </>
    }
    subtitle={
      <>
        Zego partners with FREE NOW to bring you great rates
        <br />
        on your next taxi insurance policy!
      </>
    }
    content={
      <>
        <Content.Sub1>
          Zego’s taxi insurance is designed for SPSV drivers. Our cover offers
          you great protection at competitive prices.
        </Content.Sub1>
        <Content.Text>
          As a FREE NOW driver you can access competitive prices thanks to
          Zego. Save up to 12% on taxi insurance when you choose a{' '}
          <Link href={'https://www.zego.com/sense/'} target="_blank">
            Sense policy
          </Link>
          .
        </Content.Text>
      </>
    }
  />
);

export default withPromotionsLayout(IrelandTaxiFreeNowLandingPage, {
  title: 'Get on the road with Free Now',
  description: 'Taxi and SPSV insurance for Free Now drivers by Zego.',
  ogImage: FreeNowSocial,
});
